<div class="editor">
    <textarea nz-input class="json-area" [ngModel]="text()" (ngModelChange)="text.set($event)"
        [nzAutosize]="{ minRows: 12, maxRows: 20 }" spellcheck="false" autocomplete="off" autocapitalize="off"
        autocorrect="off"></textarea>

    @if (parseError(); as err) {
    <nz-alert class="status" nzType="error" nzShowIcon [nzMessage]="'Invalid JSON: ' + err" />
    } @else {
    <nz-alert class="status" nzType="success" nzShowIcon nzMessage="Valid JSON" />
    }

    <div class="actions">
        <button nz-button (click)="reset()">Reset</button>
        <button nz-button nzType="primary" [nzLoading]="saving()" [disabled]="!isValid() || saving()"
            (click)="onSave()">
            Save
        </button>
    </div>
</div>
